namespace Areas.Account.List {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Account", ["Active", "Closed"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function onGridSelectionChanged(e: any) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            enableButton("EditButton");
        } else {
            disableButton("EditButton");
        }
    }


    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Profile/View/{placeholder}' target=\"_blank\">View</a>");
    }

    export function view() {
        gotoSelected("AccountsGrid", "/Account/Profile/View/");
    }

    export function edit() {
        gotoSelected("AccountsGrid", "/Account/Profile/Edit/");
    }

    export function showCreate() {
        const createProjectDialog = new Areas.Dialogs.CreateProjectDialog(() => { });
    }

    export function insertRecord(e: any) {
        const form = $("#AccountForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const newData: any = form.option("formData");

            sendRequest("/Account/List/Post", JSON.stringify(newData), "POST");
        }
    }

}